import { Component, OnDestroy, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { SummaryCardComponent, ExtendedNotificationComponent } from '@next/core-lib/components';
import { TranslatePipe } from '@next/core-lib/i18n';
import { Store } from '@ngrx/store';
import { Subscription, debounceTime } from 'rxjs';

import { DiscountSettings } from '../../models/setting.model';
import { upsertDiscountSettings } from '../../store/actions/setting.actions';
import { getDiscountSettings } from '../../store/selectors/setting.selector';

@Component({
  selector: 'app-discount-setting',
  templateUrl: './discount-setting.component.html',
  imports: [
    SummaryCardComponent,
    MatFormField,
    MatInput,
    ReactiveFormsModule,
    ExtendedNotificationComponent,
    TranslatePipe,
  ],
})
export class DiscountSettingComponent implements OnDestroy {
  private readonly store = inject(Store);

  public readonly formGroup = new FormGroup({
    memberDiscountNL: new FormControl<number>(null),
    memberBenefitNL: new FormControl<number>(null),
    memberBenefitAbroad: new FormControl<number>(null),
  });

  private readonly subscription = new Subscription();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    const sub = this.formGroup.valueChanges
      .pipe(debounceTime(400))
      .subscribe((discountValues: DiscountSettings) =>
        this.store.dispatch(upsertDiscountSettings({ discountSettings: discountValues })),
      );

    const sub2 = this.store.select(getDiscountSettings).subscribe((discountSettings) => {
      if (discountSettings) {
        this.formGroup.patchValue(discountSettings, { emitEvent: false });
      }
    });

    this.subscription.add(sub);
    this.subscription.add(sub2);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
